import { Grid } from "@mui/material";
import Label from "../../../libs/rhf-mui/ui/Label";
import { Lang } from "../../dao/SpwkUtil";
import { UniQuestion } from "../../dao/UniQuestion";
import { useTranslation } from "react-i18next";

type Props = {
  question: UniQuestion;
  LangA: Lang;
  LangB: Lang;
};

const UcTitle = ({ question, LangA, LangB, ...props }: Props) => {
  const { t } = useTranslation();

  return (
    <Grid container sx={{ pt: 4, pb: 0 }} direction={"column"}>
      {render_Title()}
    </Grid>
  );

  function render_Title() {
    let title_props: any = { ...{ xs: "auto", sm: "auto" } };

    let title_a = t(question.question_title);
    let title_b = question.getTitleLangB(LangB ?? "");

    let variant =
      question.variant == null || question.variant === ""
        ? "subtitle2"
        : question.variant;

    let fore_color = "#1F4E79"; // 深藍
    if (variant === "h6") {
      //#region 章節標題
      fore_color = "text.primary";

      //#endregion
    } else if (variant === "subtitle2") {
      //#region 一般標題
      fore_color = "text.primary";

      //#endregion
    } else if (variant === "body2") {
      //#region 題目標題
      fore_color = "text.primary";

      //#endregion
    } else {
      // pass
    }

    return (
      <Grid
        item
        container
        {...title_props}
        sx={{ py: "0px" }}
        direction="column"
      >
        {title_a != null && title_a === "" ? undefined : (
          <Grid item>
            <Label color={fore_color} variant={variant as any} bold>
              {title_a}
            </Label>
          </Grid>
        )}
        <Grid item>
          {title_b != null && title_b !== "" ? (
            <Label variant="caption" color="text.disabled" sx={{ pl: "4px" }}>
              {" "}
              {title_b}{" "}
            </Label>
          ) : (
            <></>
          )}
        </Grid>
      </Grid>
    );
  }
};

export default UcTitle;
